import { Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

type Status = "loading" | "admin" | "user" | "unauthenticated";

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<Status>("loading");
  const location = useLocation();

  useEffect(() => {
    fetch("/api/sessions", { credentials: "include" })
      .then(async (res) => {
        if (!res.ok) return setStatus("unauthenticated");
        const session = await res.json();
        setStatus(session?.role === "admin" ? "admin" : "user");
      })
      .catch(() => setStatus("unauthenticated"));
  }, []);

  if (status === "loading") return null;
  if (status === "unauthenticated")
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (status === "user") return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default AdminRoute;
